import React, { ReactNode, useEffect } from 'react';
import NewRequestCard from '../Cards/NewRequestCard';
import RemindersCard from '../Cards/RemindersCard';
import RequestStatCard from '../Cards/RequestStatCard';
import WhiteListedRequestCard from '../Cards/WhiteListedRequestCard';
import { useList } from '../../hooks/Request/useList';


const ApproverDashboard: React.FC = () => {

    const requestList = useList();

    useEffect(() => {
        requestList?.fetchList();
    }, []);
    return (
        <>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-2.5">
                <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.newRequestListCount ? requestList?.newRequestListCount.toString() : "0"} label={"New"} bgColour="bg-request-status-new"/>
                <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.waitListedListCount ? requestList?.waitListedListCount.toString() : "0"} label={"Waitlisted"} bgColour="bg-request-status-waitlisted"/>
            </div>

            <div className="mt-4 grid grid-cols-12 gap-4 md:mt-6 2xl:mt-7.5 2xl:gap-7.5">
                <NewRequestCard />
                <WhiteListedRequestCard />
            </div>
        </>        
    );
};

export default ApproverDashboard;